import { Component, OnInit } from "@angular/core";
import {
  MatTableDataSource,
} from "@angular/material";
import { AppService } from "src/_services/app.service";
import { Router } from "@angular/router";
import * as moment from "moment";

interface SportBetSummary {
  sportId: string;
  sportName: string;
  totalBetsCount: number;
  bfGGR: number;
  srGGR: number;
}

@Component({
  selector: "app-arbitrage-report",
  templateUrl: "./arbitrage-report.component.html",
  styleUrls: ["./arbitrage-report.component.scss"],
})
export class ArbitrageReportComponent implements OnInit {
  selected: any = { startDate: null, endDate: null };
  userInfo: any = JSON.parse(sessionStorage.getItem("currentUser"));
  summaryList = new MatTableDataSource<SportBetSummary>([]);
  displayedColumns: string[] = [
    "sportName",
    "totalBetsCount",
    "srGGR",
    "bfGGR",
    "totalGGR",
  ];
  loading: boolean = false;

  startOfDay = moment().subtract(1, "days").startOf("day");
  endOfDay = moment().subtract(1, "days").endOf("day");
  ranges: any = {
    Today: [moment().startOf("day"), moment().endOf("day")],
    Yesterday: [moment(this.startOfDay), moment(this.endOfDay)],
    "Last 7 Days": [
      moment(moment().subtract(6, "days").startOf("day")),
      moment(),
    ],
    "Last 30 Days": [
      moment(moment().subtract(29, "days").startOf("day")),
      moment(),
    ],
    "This Month": [moment().startOf("month"), moment()],
    "Last Month": [
      moment().subtract(1, "month").startOf("month"),
      moment().subtract(1, "month").endOf("month"),
    ],
  };

  constructor(private appService: AppService, private router: Router) { }

  ngOnInit() {
    // Initialize with default date range (yesterday)
    this.selected = {
      startDate: moment().startOf("day").toDate(),
      endDate: moment().endOf("day").toDate(),
    };
  }

  onDateChangeHandler = (event: any) => {
    this.selected = event;
  };

  applyFilters = () => {
    if (!this.selected.startDate || !this.selected.endDate) {
      this.appService.openErrorBar("Please select both start and end dates");
      return;
    }

    this.loading = true;
    const filters = {
      startTime: Math.floor(new Date(this.selected.startDate).getTime() / 1000),
      endTime: Math.floor(new Date(this.selected.endDate).getTime() / 1000),
    };

    this.appService.getArbitrageBetsSummary(filters).subscribe(
      (res) => {
        this.loading = false;
        if (res.status === "RS_OK") {
          const data = res.summary || res.data || [];
          this.summaryList = new MatTableDataSource<SportBetSummary>(data);
        } else if (res.errorDescription === "Invalid Token!") {
          this.appService.openErrorBar(res.errorDescription);
          sessionStorage.clear();
          this.router.navigateByUrl("/login");
        } else {
          this.appService.openErrorBar(
            res.errorDescription || "Failed to fetch arbitrage report"
          );
        }
      },
      (error) => {
        this.loading = false;
        const errorMessage = (error.error && error.error.errorDescription)
          ? error.error.errorDescription
          : "Error fetching arbitrage report";
        this.appService.openErrorBar(errorMessage);
      }
    );
  };

  calculateTotalGGR(bfGGR: number, srGGR: number): number {
    return (bfGGR || 0) + (srGGR || 0);
  }

  formatGGR(value: number): string {
    if (value === null || value === undefined) {
      return "0";
    }
    return value.toFixed(0);
  }

  getGGRClass(value: number): string {
    if (value > 0) {
      return "ggr-positive";
    } else if (value < 0) {
      return "ggr-negative";
    }
    return "";
  }

  navigateToEventLevel(element: SportBetSummary) {
    if (!element || !element.sportId) {
      return;
    }

    const queryParams = {
      sportId: element.sportId,
      sportName: element.sportName || element.sportId,
      startTime: this.selected.startDate
        ? Math.floor(new Date(this.selected.startDate).getTime() / 1000)
        : 0,
      endTime: this.selected.endDate
        ? Math.floor(new Date(this.selected.endDate).getTime() / 1000)
        : 0,
    };

    this.router.navigate(["/reports/event-arbitrage-report"], {
      queryParams: queryParams,
    });
  }
}

